import { GET_USER_REDEEMS, GET_USER_REDEEMS_FAIL, GET_USER_REDEEMS_SUCCESS, GET_USER_REFERRAL, GET_USER_REFERRAL_FAIL, GET_USER_REFERRAL_SUCCESS, SEND_REFERRAL_MAIL, SEND_REFERRAL_MAIL_FAIL, SEND_REFERRAL_MAIL_SUCCESS } from "./actionType";

export const getUserReferrals = (data, callback) => ({
    type: GET_USER_REFERRAL ,
    payload:{ data,callback}
  });
  export const getUserReferralsSuccess = (data) => ({
    type: GET_USER_REFERRAL_SUCCESS,
    payload: data,
  });
  export const getUserReferralsFail = (error) => ({
    type: GET_USER_REFERRAL_FAIL,
    payload: error,
  });


  export const sendReferralMail = (data, callback) => ({
    type: SEND_REFERRAL_MAIL ,
    payload:{ data,callback}
  });
  export const sendReferralMailSuccess = (data) => ({
    type: SEND_REFERRAL_MAIL_SUCCESS,
    payload: data,
  });
  export const sendReferralMailFail = (error) => ({
    type: SEND_REFERRAL_MAIL_FAIL,
    payload: error,
  });



  export const getUserRedeems = (data, callback) => ({
    type: GET_USER_REDEEMS ,
    payload:{ data,callback}
  });
  export const getUserRedeemsSuccess = (data) => ({
    type: GET_USER_REDEEMS_SUCCESS,
    payload: data,
  });
  export const getUserRedeemsFail = (error) => ({
    type: GET_USER_REDEEMS_FAIL,
    payload: error,
  });

